import React from "react";

const TotalPrivacy = () => {
  return (
    <div className="flex flex-col items-start  sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide  xl:text-center text-start">
        G.
        <span className="text-[#01A7D1] ">
          {" "}
          UPDATING, DELETING AND CORRECTING YOUR PERSONAL INFORMATION
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You may choose to restrict the collection or use of your personal
        information in the following ways:
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You can review, correct and delete your personal information by emailing
        us at operations@Yostelliving.com. You must promptly reach out to us to
        change your information if your personal information changes or is
        inaccurate. Typically, we will not manually alter your personal
        information because it is very difficult to verify your identity
        remotely. Nonetheless, upon your request we may close your account and
        remove your personal information from view as soon as reasonably
        possible based on your account activity and in accordance with
        applicable law. We do retain information from closed accounts in order
        to comply with the law, prevent fraud, collect any fees owed, resolve
        disputes, troubleshoot problems, assist with any investigations of any
        user, enforce our terms and conditions, and take any other actions
        otherwise permitted by law that we deem necessary in our sole and
        absolute discretion. You should understand, however, that once you
        publicly post a request, offer, comment, feedback, or any other
        information onto the Platform, you may not be able to change or remove
        it. Once we have deleted or removed your account, you agree that Yostel
        shall not be responsible for any personal information that was not
        included within your deleted and/or removed account that remains on the
        Platform.
      </p>

      <h1 className="text-[1.9rem] font-bold tracking-wide xl:text-center text-start pt-6">
        H.
        <span className="text-[#01A7D1] ">
          {" "}
          WHAT CHOICES DO I HAVE REGARDING USE OF MY PERSONAL INFORMATION?
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        We may send periodic promotional or informational emails to you. You may
        opt-out of such communications by following the opt-out instructions
        contained in the email. Please note that it may take up to 10 business
        days for us to process opt-out requests. If you opt-out of receiving
        emails about recommendations or other information we think may interest
        you, we may still send you emails about your account or any Services you
        have requested or received from us.
      </p>
      <h1 className="text-[1.9rem] font-bold tracking-wide pt-6">
        I.
        <span className="text-[#01A7D1] "> THIRD-PARTY AD NETWORKS</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        We participate in third party ad networks that may display
        advertisements on other websites based on your visits to our Platform as
        well as other websites. This enables us and these third parties to
        target advertisements by displaying ads for products and services in
        which you might be interested. Third party ad network providers,
        advertisers, sponsors and/or traffic measurement services may use
        Cookies, JavaScript, web beacons (including clear GIFs), Flash LSOs and
        other technologies to measure the effectiveness of their ads and to
        personalize advertising content to you. These third party Cookies and
        other technologies are governed by each third party's specific privacy
        policy, and not by Yostel’s Policy. We may provide these third-party
        advertisers with information about your usage of our Site and our
        services, as well as aggregate or non-personally identifiable
        information about visitors to our Site and users of our service.
      </p>
      <h1 className="text-[1.9rem] font-bold tracking-wide pt-6">
        J.
        <span className="text-[#01A7D1] ">
          {" "}
          INFORMATION SHARED WITH THIRD PARTY
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The Platform facilitates your sharing of personal information with
        others in order to negotiate, provide, and use the Services. If you
        agree to contract for a service with another user or third party, you
        may need to reveal your name, email, phone number, or personal address
        to that individual so that the service may be performed. Please respect
        the privacy of others. You agree to use the information of other users
        solely for using Services offered through the Platform.
      </p>
      <h1 className="text-[1.9rem] font-bold tracking-wide pt-6">
        K.
        <span className="text-[#01A7D1] "> PASSWORD</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Our password is the key to your account. When creating your password you
        should use unique numbers, letters, special characters, and combinations
        thereof. In addition, DO NOT disclose your password to anyone. If you do
        share your password or your personal information with others, you are
        solely responsible for all actions taken via your account. If you lose
        control of your password, you may lose substantial control over your
        personal information and be subject to legally binding actions taken on
        your behalf. Thus,{" "}
        <span className="text-lg">
          IF YOUR PASSWORD HAS BEEN COMPROMISED FOR ANY REASON, YOU MUST
          IMMEDIATELY NOTIFY Yostel TO CHANGE YOUR PASSWORD.
        </span>
      </p>
      <h1 className="text-[1.9rem] font-bold tracking-wide pt-6">
        L.
        <span className="text-[#01A7D1] "> USER GENERATED CONTENT</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        We invite you to post content on our Platform, including your comments,
        feedback, pictures, and any other information that you would like to be
        available on our Platform. If you post content to our Platform, all of
        the information that you post will be available to all visitors to our
        Platform. If you post your own content on our Platform or Services, your
        posting may become public and Yostel cannot prevent such information
        from being used in a manner that may violate this Policy, the law, or
        your personal privacy.
      </p>
      <h1 className="text-[1.9rem] font-bold tracking-wide pt-6">
        M.
        <span className="text-[#01A7D1] "> COMPLIANCES</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Yostel is an ISO 27001:2013 certified company and have implemented
        reasonable security practices and procedures for data protection of its
        users.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Yostel's use of any information received from the Google APIs will
        adhere to{" "}
        <a href="#" className="text-blue-500 underline">
          Google API Services User Data Policy.
        </a>
      </p>
      <h1 className="text-[1.9rem] font-bold tracking-wide pt-6">
        N.
        <span className="text-[#01A7D1] "> UPDATES AND AMENDMENTS</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        This Policy is valid from the effective date set forth above. Yostel
        may, in its sole and absolute discretion, change this Policy from time
        to time by updating this document. Yostel will post its updated Policy
        on the platform on this page. Yostel encourages you to review this
        Policy regularly for any changes. Your continued use of this Platform
        and/or continued provision of Personal Information to us will be subject
        to the terms of the then-current Policy.
        <br />© 2025 Yostel. All Rights Reserved.
      </p>
    </div>
  );
};

export default TotalPrivacy;
